import { defineComponent as S, ref as D, computed as s, provide as T, inject as W, onMounted as A, watch as P, h as g, Fragment as R, resolveComponent as m, createBlock as v, openBlock as y, normalizeClass as w, withCtx as h, createElementVNode as k, createVNode as F, createCommentVNode as V, createTextVNode as C, toDisplayString as B } from "vue";
import { H as N, t as H, o as J, K as M, T as I, a as x } from "./dom-B5R6OWVp.js";
import { E as q, T as Q, K as X, M as Y } from "./label-DS73oEMG.js";
import { b as Z } from "./use-resolve-button-type-XAZYZJQ_.js";
import { d as tt, f as et, a as nt, p as rt } from "./use-controllable-BEb0o1U6.js";
import { _ as at } from "./_plugin-vue_export-helper-CHgC5LLL.js";
let L = Symbol("GroupContext"), ot = S({ name: "SwitchGroup", props: { as: { type: [Object, String], default: "template" } }, setup(t, { slots: a, attrs: o }) {
  let l = D(null), d = X({ name: "SwitchLabel", props: { htmlFor: s(() => {
    var n;
    return (n = l.value) == null ? void 0 : n.id;
  }), onClick(n) {
    l.value && (n.currentTarget.tagName === "LABEL" && n.preventDefault(), l.value.click(), l.value.focus({ preventScroll: !0 }));
  } } }), r = Y({ name: "SwitchDescription" });
  return T(L, { switchRef: l, labelledby: d, describedby: r }), () => N({ theirProps: t, ourProps: {}, slot: {}, slots: a, attrs: o, name: "SwitchGroup" });
} }), lt = S({ name: "Switch", emits: { "update:modelValue": (t) => !0 }, props: { as: { type: [Object, String], default: "button" }, modelValue: { type: Boolean, default: void 0 }, defaultChecked: { type: Boolean, optional: !0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, value: { type: String, optional: !0 }, id: { type: String, default: () => `headlessui-switch-${H()}` } }, inheritAttrs: !1, setup(t, { emit: a, attrs: o, slots: l, expose: d }) {
  let r = W(L, null), [n, c] = tt(s(() => t.modelValue), (e) => a("update:modelValue", e), s(() => t.defaultChecked));
  function f() {
    c(!n.value);
  }
  let b = D(null), u = r === null ? b : r.switchRef, _ = Z(s(() => ({ as: t.as, type: o.type })), u);
  d({ el: u, $el: u });
  function z(e) {
    e.preventDefault(), f();
  }
  function O(e) {
    e.key === x.Space ? (e.preventDefault(), f()) : e.key === x.Enter && rt(e.currentTarget);
  }
  function j(e) {
    e.preventDefault();
  }
  let p = s(() => {
    var e, i;
    return (i = (e = J(u)) == null ? void 0 : e.closest) == null ? void 0 : i.call(e, "form");
  });
  return A(() => {
    P([p], () => {
      if (!p.value || t.defaultChecked === void 0) return;
      function e() {
        c(t.defaultChecked);
      }
      return p.value.addEventListener("reset", e), () => {
        var i;
        (i = p.value) == null || i.removeEventListener("reset", e);
      };
    }, { immediate: !0 });
  }), () => {
    let { id: e, name: i, value: E, form: U, ...$ } = t, G = { checked: n.value }, K = { id: e, ref: u, role: "switch", type: _.value, tabIndex: 0, "aria-checked": n.value, "aria-labelledby": r == null ? void 0 : r.labelledby.value, "aria-describedby": r == null ? void 0 : r.describedby.value, onClick: z, onKeyup: O, onKeypress: j };
    return g(R, [i != null && n.value != null ? g(et, M({ features: nt.Hidden, as: "input", type: "checkbox", hidden: !0, readOnly: !0, checked: n.value, form: U, name: i, value: E })) : null, N({ ourProps: K, theirProps: { ...o, ...I($, ["modelValue", "defaultChecked"]) }, slot: G, attrs: o, slots: l, name: "Switch" })]);
  };
} }), it = Q, ut = q;
const st = S({
  components: {
    SwitchWrapper: lt,
    SwitchLabel: it,
    SwitchGroup: ot,
    SwitchDescription: ut
  },
  props: {
    modelValue: [String, Number, Boolean, Array, Object],
    title: String,
    description: String,
    size: {
      type: String,
      default: () => "m"
    },
    on: {
      type: [String, Number, Boolean, Array, Object],
      default: () => !0
    },
    onUndefined: Boolean,
    off: {
      type: [String, Number, Boolean, Array, Object],
      default: () => !1
    },
    offUndefined: Boolean
  },
  setup(t, { emit: a }) {
    return {
      enabled: s({
        get() {
          return t.onUndefined && t.modelValue === void 0 ? !0 : t.offUndefined && t.modelValue === void 0 ? !1 : JSON.stringify(t.modelValue) === JSON.stringify(t.on);
        },
        set(o) {
          a("update:modelValue", o ? t.onUndefined ? void 0 : t.on : t.offUndefined ? void 0 : t.off);
        }
      }),
      sizes: s(() => t.size === "m" ? {
        wrap: "tt-h-6 tt-w-11",
        centerWrap: "tt-mb-3 tt-mt-1",
        button: "tt-h-5 tt-w-5",
        translateButton: "tt-translate-x-5"
      } : {
        wrap: "tt-h-4 tt-w-7",
        centerWrap: "tt-mb-2 tt-mt-1",
        button: "tt-h-3 tt-w-3",
        translateButton: "tt-translate-x-3"
      })
    };
  }
}), dt = { class: "tt-flex-grow tt-flex tt-flex-col tt-px-1" };
function ct(t, a, o, l, d, r) {
  const n = m("SwitchLabel"), c = m("SwitchDescription"), f = m("SwitchWrapper"), b = m("SwitchGroup");
  return y(), v(b, {
    as: "div",
    class: w(["tt-inline-flex tt-items-center tt-justify-between", t.sizes.centerWrap])
  }, {
    default: h(() => [
      k("span", dt, [
        t.title ? (y(), v(n, {
          key: 0,
          as: "span",
          class: "tt-text-sm tt-font-medium tt-text-gray-900 tt-pr-2",
          passive: ""
        }, {
          default: h(() => [
            C(B(t.title), 1)
          ]),
          _: 1
        })) : V("", !0),
        t.description ? (y(), v(c, {
          key: 1,
          class: "tt-text-sm tt-text-gray-500"
        }, {
          default: h(() => [
            C(B(t.description), 1)
          ]),
          _: 1
        })) : V("", !0)
      ]),
      F(f, {
        modelValue: t.enabled,
        "onUpdate:modelValue": a[0] || (a[0] = (u) => t.enabled = u),
        class: w([t.enabled ? "tw-bg-primary" : "tt-bg-gray-200", t.sizes.wrap + " tt-relative tt-inline-flex tt-flex-shrink-0 tt-border-2 tt-border-transparent tt-rounded-full tt-cursor-pointer tt-transition-colors tt-ease-in-out tt-duration-200 focus:tt-outline-none focus:tt-ring-2 focus:tt-ring-offset-2 focus:tw-ring-primary"])
      }, {
        default: h(() => [
          k("span", {
            "aria-hidden": "true",
            class: w([t.enabled ? t.sizes.translateButton : "tt-translate-x-0", t.sizes.button + " tt-pointer-events-none tt-inline-block tt-rounded-full tt-bg-white tt-shadow tt-transform tt-ring-0 tt-transition tt-ease-in-out tt-duration-200"])
          }, null, 2)
        ]),
        _: 1
      }, 8, ["modelValue", "class"])
    ]),
    _: 1
  }, 8, ["class"]);
}
const yt = /* @__PURE__ */ at(st, [["render", ct]]);
export {
  yt as default
};
//# sourceMappingURL=Switch-DBG6RDCK.js.map
